import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogService } from '@nrwl/dialog-service';
import { RxIconModule } from '@nrwl/rx-icon';
import { ClickOutsideModule } from 'ng-click-outside';

@Component({
  selector: 'rx-popover-auth',
  templateUrl: './rx-popover-auth.component.html',
  styleUrls: ['./rx-popover-auth.component.scss'],
  imports: [CommonModule, ClickOutsideModule, RxIconModule],
})
export class RxPopoverAuthComponent implements OnInit {
  buttons: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogService: DialogService,
    public dialogRef: MatDialogRef<RxPopoverAuthComponent>,
  ) {}

  ngOnInit(): void {
    this.buttons = this.data.payload.buttons;
  }

  public login(value): void {
    this.closePopup(value);
  }

  public closePopup(value?): void {
    this.dialogRef.close(value);
  }
}
